import { getDistribution, getShellVersion } from './distribution';

const INSTALL_ID_KEY = 'qixit_install_id';

function createInstallId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `qixit-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getOrCreateInstallId(): string {
  const current = localStorage.getItem(INSTALL_ID_KEY);
  if (current && current.trim()) return current;
  const next = createInstallId();
  localStorage.setItem(INSTALL_ID_KEY, next);
  return next;
}

export function getDeviceClass(): string {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('ipad') || ua.includes('tablet')) return 'tablet';
  if (ua.includes('android') || ua.includes('iphone') || ua.includes('mobile')) return 'phone';
  return 'desktop';
}

export function getClientSignalHeaders(): Record<string, string> {
  return {
    'X-Qixit-Distribution': getDistribution(),
    'X-Qixit-Device-Class': getDeviceClass(),
    'X-Qixit-Os-Name': navigator.platform || 'unknown',
    'X-Qixit-Os-Version': navigator.userAgent,
    'X-Qixit-App-Version': getShellVersion() || 'web',
    'X-Qixit-Install-Id': getOrCreateInstallId(),
  };
}
